import * as Yup from "yup";
import { Device } from "../../../entity/Device";
import { Tag } from "../../../entity/Tag";
import { PullDownItem } from "../../common/form/FormPullDown";

/**
 * 端末一覧取得API リクエスト
 */
export class DeviceSearchRequest {
  imei?: string;
  tenantIds?: string[];
  telNumber?: string;
  modelName?: string;
  isDataLimit?: boolean;
  deviceUser?: string;
  isOnline?: string;
  isSimReplaced?: boolean;
  simSwapDateStart?: Date;
  simSwapDateEnd?: Date;
  createDateStart?: Date;
  createDateEnd?: Date;
  lockOption?: string;
  tagName?: string[];
}

/**
 * 端末一覧取得API レスポンス
 */
export class DeviceSearchResponse {
  /** デバイスID */
  public id: string = "";
  /** IMEI */
  public imei: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 電話番号 */
  public telNumber: string = "";
  /** 機種 */
  public model = "";
  /** device名(Nickname) */
  public deviceName = "";
  /** SIm or eSIM */
  public simType = "";
  /** 通信事業者 */
  public carrier = "";
  /** オンライン／オフライン */
  public isOnline = "";
  /** 端末利用者 */
  public deviceUser = "";
  /** SIM通信量（累積） */
  public simTraffic = "";
  /** SIM2通信量（累積） */
  public sim2Traffic = "";
  /** eSIM通信量（累積） */
  public esimTraffic = "";
  /** FW Ver */
  public firmware = "";
  /** 通信規制の有無 */
  public isDataLimit = "";
  /** SIM差替／SIM抜きの有無 */
  public simSwapped = "";
  /** 登録日時 */
  public createDate = "";
  /** タグ */
  public tag: Tag[] = [];
  /** ラベル */
  public label: string = "";
}

/**
 * 端末詳細取得API リクエスト
 */
export class DeviceDetailRequest {
  /** 端末ID */
  public id: string = "";

  /** SIM差し替えログ日時検索（開始日） */
  public simReplacementLogDateStart: string = "";

  /** SIM差し替えログ日時検索（終了日） */
  public simReplacementLogDateEnd: string = "";
}

/**
 * 端末詳細取得API レスポンス
 */
export class DeviceDetailResponse {
  public serialNumber: string = "";
  public devsn: string = "";
  public softver: string = "";
  public hardver: string = "";
  public mem_use: string = "";
  public cpu_use: string = "";
  public workmode: string = "";
  public longitude: string = "";
  public latitude: string = "";
  public nettype: string = "";
  public autoupload: string = "";
  public sim1: Sim1 = new Sim1();
  public wan: Wan = new Wan();
  public lan: Lan = new Lan();
  public wlan: Wlan = new Wlan();

  /** IMEI */
  public imei: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 機種 */
  public modelName: string = "";
  /** デバイス名 */
  public deviceName: string = "";
  /** SIM or eSIM */
  public simType: string = "";
  /** 通信事業者 */
  public carrier: string = "";
  /** IMSI */
  public imsi: string = "";
  /** ICCID */
  public iccid: string = "";
  /** 通信状態 */
  public status: string = "";
  /** ネットワーク */
  public network: string = "";
  /** 登録日時 */
  public createDate: string = "";
  /** 接続時間 */
  public connTime: string = "";
  /** IPアドレス（DHCP） */
  public ipAddress: string = "";
  /** WAN IPアドレス */
  public wanIp: string = "";
  /** プライマリDNSアドレス */
  public dnsP: string = "";
  /** セカンダリDNSアドレス */
  public dnsS: string = "";
  /** WAN IPv6アドレス */
  public wanIp6: string = "";
  /** IPv6プライマリDNSアドレス */
  public dns6P: string = "";
  /** IPv6セカンダリDNSアドレス */
  public dns6S: string = "";
  /** 電池残量 */
  public battery: string = "";
  /** ネットワークタイプ */
  public networkType: string = "";
  /** 基地局情報 */
  public cellInfo: CellInfo = new CellInfo();
  /** 電波強度のレベル（閾値での判定後の値） */
  public signalLevel: string = "";
  /** 電波強度の取得日時 */
  public signalUpdateDate: string = "";
  /** オンライン／オフライン */
  public isOnline: string = "";
  /** 利用者 */
  public username: string = "";
  /** SIM通信量（累積、1か月、3日間、1日） */
  public simTraffic: string = "";
  public simTraffic1m: string = "";
  public simTraffic3d: string = "";
  public simTraffic1d: string = "";
  /** SIM2通信量（累積、1か月、3日間、1日） */
  public sim2Traffic: string = "";
  public sim2Traffic1m: string = "";
  public sim2Traffic3d: string = "";
  public sim2Traffic1d: string = "";
  /** eSIM通信量（累積、1か月、3日間、1日） */
  public esimTraffic: string = "";
  public esimTraffic1m: string = "";
  public esimTraffic3d: string = "";
  public esimTraffic1d: string = "";
  /** ファームバージョン */
  public firmware: string = "";
  /** 通信規制の有無 */
  public isDataLimit: string = "";
  /** SIM差替／SIM抜きの有無 */
  public simSwapped: string = "";
  /** SIM差替えログ */
  public simSwapLogs: SimSwapLogs[] = [];
  /** MDM管理 */
  public isMdmManaged: boolean = false;
  /** コメント */
  public comment: string = "";
  /** タグ */
  public tag: Tag[] = [];
  /** ラベル */
  public label: string = "";
  /** 電話番号 */
  public phoneNumber: string = "";
  /** MACアドレス */
  public macAddress: string = "";
  /** EID */
  public eid: string = "";
  /** 無線LAN(Wi-Fi)接続情報（SSID1, SSID2, Guest） */
  public wifiInfo: WifiInfo[] = [
    new WifiInfo(),
    new WifiInfo(),
    new WifiInfo(),
  ];

   /** FS045W無線LAN(Wi-Fi)接続情報（SSID1, SSID2） */
   public wifiInfoFS045W: WifiInfoFS045W[] = [
    new WifiInfo(),
    new WifiInfo(),
  ];
  /** FS010C無線LAN(Wi-Fi)接続情報（メイン2.4GHz, メイン5GHz, Guest（2.4GHz, 5GHz）） */
  public wifiInfoFS010C: WifiInfoFS010C[] = Array.from({ length: 1 + 1 + 3 + 3 }, () => new WifiInfoFS010C());
  /** 接続機器一覧 */
  public equipments: Equipments[] = [];
  /** ボタン操作ロック */
  public buttonLock: boolean = false;
  /** Web UIロック */
  public webuiLock: boolean = false;
  /** 通信ロック */
  public connLock: boolean = false;
  /** MDMロック */
  public mdmLock: boolean = false;
  /** RNDIS → RAS切替 */
  public rndisRas: string = "";
  /** 最終通知日時 */
  public lastNotificationDate: string = "";
  /** 診断 */
  public diagnosis: Diagnosis | null = null;
  /** MCC（m2u300） */
  public mnetMcc: string = "";
  /** MNC（m2u300） */
  public mnetMnc: string = "";
  /** ネットワークインターフェース（m2u300） */
  public networkInterface: NetworkInterface[] = [];
  /** PING疎通結果（m2u300） */
  public ping: PingResult[] = [];
  /** 電波品質スナップショット（m2u300） */
  public radioSnapshot: RadioSnapshot = new RadioSnapshot();
  signalDetail: string = "";
}
/** 無線LAN(Wi-Fi)接続情報 */
export class WifiInfo {
  public status: string = "";
  public ssid: string = "";
  public passwd: string = "";
  public securityProtocol: string = "";
  public freq: string = "";
}

/** FS045W無線LAN(Wi-Fi)接続情報 */
export class WifiInfoFS045W {
  public status: string = "";
  public ssid: string = "";
  public passwd: string = "";
  public securityProtocol: string = "";
  public freq: string = "";
}
/** FS010C無線LAN(Wi-Fi)接続情報 */
export class WifiInfoFS010C {
  public status: string = "";
  public ssid: string = "";
  public passwd: string = "";
  public securityProtocol: string = "";
}
/** 接続機器一覧 */
export class Equipments {
  public name: string = ""; // 接続機器名
  public mac: string = ""; // MACアドレス
  public ip: string = ""; // IPアドレス
  public form: string = ""; // 接続形態
  public connectionMode: string = ""; // 接続形態
  public connectionStatus: string = ""; // 接続状態
  public connectionTime: string = ""; // 接続時刻
  public pingStatus: string = ""; // PINGステータス
}
/** SIM差替えログ */
export class SimSwapLogs {
  public swapDate: string = ""; // 差替え日時
  public iccid: string = ""; // ICCID
  public simType: string = ""; // SIMタイプ
}

/** 診断 */
export class Diagnosis {
  public date: string = ""; // 診断日時
  public type: string = ""; // 診断タイプ
  public result: string = ""; // 診断結果
  public detail: string = ""; // 診断詳細
}

export type RadioCellRole = "PRIMARY" | "SECONDARY" | "SCC";

/** 電波品質・セル情報（m2u300） */
export class RadioCell {
  public role: RadioCellRole = "PRIMARY";
  /** "LTE" / "NR5G" / "NR5G-SA" など端末が通知する値をそのまま保持 */
  public rat: string = "";
  public carrierIndex: number = 0;
  public band: string = "";
  public cellId: string = "";
  public pci: number | null = null;
  public arfcn: number | null = null;
  public rsrpDbm: number | null = null;
  public sinrDb: number | null = null;
  public rsrqDb: number | null = null;
}

/** 電波品質スナップショット（m2u300） */
export class RadioSnapshot {
  public measuredAt: string = "";
  public mode: "SA" | "NSA" | "NR_DC" | "NR_CA" | "EN_DC" | "UNKNOWN" | "" = "";
  public cells: RadioCell[] = [];
}

/** ネットワークインターフェース（m2u300） */
export class NetworkInterface {
  public name: string = "";
  public status: string = "";
}

/** PING疎通結果（m2u300） */
export class PingResult {
  public ip: string = "";
  /** 0:到達 / 0以外:未到達 */
  public status: number | null = null;
  /** ミリ秒 */
  public latency: number | null = null;
}

// FS010M SIM1
export class Sim1 {
  public status: string = "";
  public csq: string = "";
  public nettype: string = "";
  public lac: string = "";
  public ci: string = "";
  public sid: string = "";
  public bid: string = "";
  public nid: string = "";
  public ip: string = "";
  public ipv6: string = "";
  public iccid: string = "";
  public imsi: string = "";
  public imei: string = "";
  public netband: string = "";
  public rsrp: string = "";
  public rsrq: string = "";
  public sinr: string = "";
  public totaltx: string = "";
  public totalrx: string = "";
  public operator: string = "";
  public uptimes: string = "";
  public offtime: string = "";
  public moduleVersion: string = "";
}
// FS010M WAN
export class Wan {
  public status: string = "";
  public mode: string = "";
  public ip: string = "";
  public ipv6: string = "";
}
// FS010M LAN
export class Lan {
  public status: string = "";
  public ip: string = "";
}
// FS010M WLAN
export class Wlan {
  public mode: string = "";
  public ip: string = "";
  public signal: string = "";
  public txpower: string = "";
  public channel: string = "";
  public number: string = "";
}

// 基地局情報
export class CellInfo {
  public cellId: string = "";
  public mcc: string = "";
  public mnc: string = "";
  public tac: string = "";
  public lac: string = "";
}

/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  deviceNameIsNull: "デバイス名を入力してください",
  newPinIsNull: "新しいPINコードを入力してください",
  csvFileIsNull: "ファイルを選択してください",
  tenantIsNull: "テナントを選択してください",
};
/**
 * バリデーションルール
 */
export const TerminalEditFormSchema = Yup.object({
  // deviceUserId: Yup.string().required(ERR_MESSAGE.usernameIsNull),
});

// 新規追加用
export class DeviceCreateRequest {
  editdata: Device = new Device();
}

/**
 * 端末編集API リクエスト(入力用)
 * 編集用
 */
export class TerminalEditForm {
  /** IMEI */
  public imei: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 機種 */
  public modelName: string = "";
  /** デバイス名 */
  public deviceName: string = "";
  /** 利用者ID */
  public deviceUserId: string = "";
  /** 組織ID */
  public orgId: string = "";
  /** コメント */
  public comment: string = "";
  /** コメントモード*/
  public commentMode: string = "1"; // デフォルト上書き
  /** タグ */
  public tagId: string[] = [];
  /** タグモード */
  public tagMode: string = "1"; // デフォルト上書き
  /** MDM有効化/無効化 */
  public isMdmManaged: boolean | undefined;
  // タグ選択(退避用)
  public selectTag: PullDownItem[] = [];
}

/**
 * バリデーションルール
 */
export const TerminalImportConfirmFormSchema = Yup.object({
  csvFile: Yup.string().required(ERR_MESSAGE.csvFileIsNull),
  tenant: Yup.string().required(ERR_MESSAGE.tenantIsNull),
});

/**
 * ユーザーインポート確認フォーム(入力チェック用)
 */
export class TerminalImportConfirmForm {
  /** CSVファイル */
  public csvFile: any;
  // /** テナントID */
  public tenant: string='';
}

/**
 * 端末インポート確認API レスポンス
 */
export class TerminalImportConfirmResponse {
  /** エラーフラグ */
  public isError: boolean = false;
  /** データ件数 */
  public dataCnt: number = 0;
  /** インポートチェック時刻 */
  public importCheckDate: string = "";
  /** インポートファイル名 */
  public importFileName: string = "";
  /** エラーリスト */
  public errorList: [] = [];
  /** テナント名 */
  public tenantName: string = "";
  /** テナントID */
  public tenantId: number = 0;
  /** エラーメッセージ */
  public errorMessages: [] = [];
}

/***************************************************************
 * 端末インポート
 **************************************************************/
/**
 * バリデーションルール
 */
export const TerminalImportFormSchema = Yup.object({
  check: Yup.bool().oneOf([true], ERR_MESSAGE.csvFileIsNull),
});

/**
 * 端末インポートフォーム(入力チェック用)
 */
export class TerminalImportForm {
  /** チェック */
  public check: boolean = false;
}

/**
 * 端末インポートAPI リクエスト
 */
export class TerminalImportRequest {
  /** インポートチェック時刻 */
  public importCheckDate: string = "";
  public tenantName: string = "";
  public tenantId: number = 0;
}

/**
 * 端末設定API リクエスト
 */
export class DeviceSettingApn {
  name = "";
  apn = "";
  user = "";
  passwd = "";
  auth = "";
  connMode = "";
}

export class DeviceSettingRequestDdns {
  connSts: string | null = null;
  prov = "";
  port = "";
  domain = "";
  user = "";
  passwd = "";
  status = false;
}

export class DeviceSettingWifiSchedule {
  kind = "";
  name = "";
  mac = "";
  startTime = "";
  endTime = "";
  dayofweek = {
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
  };
}

export class DeviceSettingMacFilter {
  status = "";
  macList = [{ mac: "" }];
}

export class DeviceSettingTrafficLimit {
  uuid = crypto.randomUUID();
  limit = "";
  unit = "";
  limitUnit = null;
  upSpeedLimitOn = false;
  upSpeedLimit = "";
  upSpeedUnit = "";
  upSpeedLimitKbps = 0;
  downSpeedLimitOn = false;
  downSpeedLimit = "";
  downSpeedUnit = "";
  downSpeedLimitKbps = 0;
}

export class DeviceSettingSpeedLimit {
  dayofweek = {
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
  };
  startTime = "";
  endTime = "";
  upSpeedLimitOn = false;
  upSpeedLimit = "";
  upSpeedUnit = "";
  upSpeedLimitKbps = 0;
  downSpeedLimitOn = false;
  downSpeedLimit = "";
  downSpeedUnit = "";
  downSpeedLimitKbps = 0;
}

export class DeviceSettingForm {
  lang = "";
  operationMode = "";
  defaultApnSim = "";
  apnSim = [new DeviceSettingApn()];
  defaultApnEsim = "";
  apnEsim = [new DeviceSettingApn()];
  apnNameValidSim = false;
  apnNameValidEsim = false;
  enabledEsimProfile = "";
  esimProfiles = [{
    iccid: "",
    nickname: "",
    spn: "",
    name: "",
  }];
  esimDel = {
    iccid: "",
  };
  maxuserValid = false;
  wifiGuestPasswordValid = false;
  simEsim = "";
  nwCond = {
    status: "",
    simNoDur: "",
    esimNoDur: "",
    pingIp: "",
  };
  dataTraffic = {
    status: "0",
    simLimit: "",
    simUnit: "",
    simLimitUnit: null,
    esimLimit: "",
    esimUnit: "",
    esimLimitUnit: null,
    dayofweek: "0",
    dayofweekList: [{
      simEsim: "",
      startHour: "",
      startMinute: "",
      endHour: "",
      endMinute: "",
    }],
  };
  prioritySwitching = {
    primary: "1",
    primaryTimer: "",
    auto: "0",
    noServicePrimary: "",
    primaryPingIp: "",
  };
  simswitchValid = false;
  nwSetting = "";
  roaming = "";
  sim = {
    maxTraffic: "",
    unit: "",
    maxTrafficUnit: null,
    notify: "",
    action: "", // 上限到達後の設定
    maxSpeed: "",
    maxSpeedUnit: "",
    autoReset: "",
    period: "",
    dayOfWeek: "",
    date: "",
  };
  esim = {
    maxTraffic: "",
    unit: "",
    maxTrafficUnit: null,
    notify: "",
    action: "", // 上限到達後の設定
    maxSpeed: "",
    maxSpeedUnit: "",
    autoReset: "",
    period: "",
    dayOfWeek: "",
    date: "",
  };
  simPin = {
    status: "",
    currentPin: "",
    newPin: "",
  };
  simAutopin = false;
  rmainingSimAttempts: string | null = null;
  pingResp = "";
  mtu = "";
  ddns = [new DeviceSettingRequestDdns()];
  wiFi = [{
    status: false,
    ssid: "",
    freq: "",
    secProtocol: "",
    passwd: "",
    broadcast: false,
    maxuser: "",
    beacon: "",
  }];
  wifi24g = {
    mode: "",
    channel: "",
    width: "",
  };
  wifi5g = {
    mode: "",
    freqband: "",
    chWidth: "",
  };
  chSearch = "";
  dhcp = {
    status: false,
    ip: "",
    subnetmask: "",
    ippoolS: "",
    ippoolE: "",
    leasetime: "",
    autoDns: "",
    primDns: "",
    secondDns: "",
    dnsService: "",
  };
  fixIp = [{
    name: "",
    ip: "",
    mac: "",
    status: false,
  }];
  macFilterSSID1 = new DeviceSettingMacFilter();
  macFilterSSID2 = new DeviceSettingMacFilter();
  macFilterGuest = new DeviceSettingMacFilter();
  wifiPwChange = false;
  wifiPwInterval = "";
  wifiSchedule = false;
  wifiScheduleList = [new DeviceSettingWifiSchedule()];
  privacy = false;
  siteBlock = "";
  pmf = false;
  usbtether = false;
  internetLimit = "";
  internetLimitList = [{
    name: "",
    mac: "",
    status: false,
  }];
  ipfilter = "";
  ipfilterList = [{
    lanIp: "",
    lanPort: "",
    wanIp: "",
    wanPort: "",
    protocol: "",
    status: false,
  }];
  portMapping = [{
    name: "",
    wanPort: "",
    lanIp: "",
    lanPort: "",
    protocol: "",
    status: false,
  }];
  urlFilter = "";
  urlFilterList = [{
    domain: "",
    status: false,
  }];
  dmz = false;
  dmzIp = "";
  nat = false;
  l2tp = false;
  pptp = false;
  ipsec = false;
  newPassword = ""; // パスワード
  dispTime = "";
  ledDisp = false; // LED点灯設定
  batteryCare = false;
  eco = "";
  sleep = "";
  autoboot = false;
  powerTimer = false;
  powerTimerList = [{
    action: "",
    dayofweek: "",
    time: "",
    status: false,
  }];
  rebootTime = false;
  rebootTimeList = [{
    dayofweek: "",
    time: "",
    status: false,
  }];
  autoUpdate = false;
  deviceOtgSwitch = false; // バッテリー給電設定
  mdmServerInterval = "";
  buttonLock = false;
  webuiLock = false;
  connLock = false;
  trafficReportPeriodic = {
    status: false,
    triggerVal: "",
  };
  trafficReportStepwise = {
    status: false,
    triggerVal: "",
  };
  trafficLimitSim = {
    enabled: false,
    resetPeriod: "",
  };
  trafficLimitEsim = {
    enabled: false,
    resetPeriod: "",
  };
  trafficLimitListSim = [new DeviceSettingTrafficLimit()];
  trafficLimitListEsim = [new DeviceSettingTrafficLimit()];
  speedLimitEnabledSim = false;
  speedLimitEnabledEsim = false;
  speedLimitSim = [new DeviceSettingSpeedLimit()];
  speedLimitEsim = [new DeviceSettingSpeedLimit()];
  esimOpt = {
    actCode: "",
    cmfCode: "",
  };
  wizard = false;
  nickname = "";
  rasswich = "";
}
export class DeviceSettingRequest {
  id: string[];
  savedata: Partial<DeviceSettingForm>;

  constructor(id: string[], savedata: Partial<DeviceSettingForm>) {
    this.id = id;
    this.savedata = savedata;
  }
}
/**
 * バリデーションルール
 */
/** 新しいPIN用のカスタムバリデーション */
const newPinValidation = Yup.string().test(
  "",
  ERR_MESSAGE.newPinIsNull,
  function (this: Yup.TestContext, newPin: string | undefined | null) {
    const { simStatus } = this.parent;

    // PIN変更処理の場合はnewPin必須
    if (!!+simStatus && simStatus === "2" && !newPin) {
      return false;
    }

    return true;
  },
)

const emptyValidation = Yup.string().test(
  "",
  ERR_MESSAGE.newPinIsNull,
  function (this: Yup.TestContext, str: string | undefined | null) {

    // PIN変更処理の場合はnewPin必須
    if (!str || str.length >= 8) {
      return false;
    }

    return true;
  },
)

export const DeviceSettingRequestSchema = Yup.object({
  simPin: Yup.object({
    status: Yup.string().required(),
    currentPin: Yup.string().required(),
    newPin: newPinValidation,
  }),
  mdmServerInterval: emptyValidation,
});

/**
 * 端末操作フォーム(入力チェック用)
 */
export class DeviceOperationForm {
  /** ファームウェアバージョン */
  public ver: string = "";
  /** 通信リセット種別 */
  public traafficResetType: string = "sim";
  /** 端末初期化種別 */
  public resetType: string = "";
}
export type DeviceCommand =
  | "powerOff"
  | "reboot"
  | "sync"
  | "update"
  | "resetTraffic"
  | "chSearch"
  | "factoryReset";
export type DeviceOperationRequest = {
  id: string[];
  command: DeviceCommand;
  kind?: string;
  ver?: string;
};
/**
 * バリデーションルール
 */
export const DeviceOperationFormSchema = Yup.object({});

// 通信量統統計リクエスト
export class TrafficDataRequest {
  /** 端末ID */
  public deviceId: string = "";
  /** 期間 */
  public period: string = "";
  /** タイプ */
  public simtype: string = "";
  /** 日付 */
  public year: number = 0;
  public month: number = 0;
}

// 通信量統計レスポンス
export class TrafficDataResponse {
  /** データ量 */
  public sendTraffic: number[] = [];
  public receiveTraffic: number[] = [];
  /** 日付 */
  public trafficDate: Date[] = [];
  public month: string[] = [];
  /** 一番古いデータ */
  public minDate: Date = new Date();
}
